module.exports = __webpack_public_path__ + "static/img/20.eeb24ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/20.jpg
// module id = TmBQ
// module chunks = 1